module.exports = __webpack_public_path__ + "img/3_185.0cde85fc.png";